import React = require('react');
import {IProileComp} from "../../interfaces/layout/blocks/IUser";
export interface IProfileItemCompProps extends IProileComp {
    onClick: Function;
	listMode?:boolean;
    index?:number;
}

interface IProfileItemCompState {
}

export class ProfileItemComp extends React.Component<IProfileItemCompProps, IProfileItemCompState>{

    constructor(props:IProfileItemCompProps){
        super(props);
    }

    render() {
		var classNames:string = 'item profileComp';
		if ( this.props.currentUser === true ) {
			classNames += ' current_user';
		}
		var listMode:boolean = false;
		if ( this.props.listMode !== undefined && this.props.listMode === true ) {
			listMode = true;
			classNames += ' list_mode';
		}

		if ( this.props.coupleBefore !== undefined && this.props.coupleBefore === true ) {
			classNames += ' couple_before';
		}

		if ( this.props.coupleAfter !== undefined && this.props.coupleAfter === true ) {
			classNames += ' couple_after';
            if ( this.props.index !== undefined ) {
                var index:number = this.props.index +1;
                if ( index % 3 === 0 ) {
                    classNames += ' break';
                }
            }
		}
        var name:string = this.props.name;
        if ( this.props.birthName !== '' ) {
            name = this.props.birthName;
        }
        return (
			<div className={classNames}>
				{ listMode === true ? <div className="row title">
						<a className="box" onClick= { e => this.props.onClick(e, this.props.fatherId) }>{ this.props.fatherName }</a>
						<a className="box" onClick= { e => this.props.onClick(e, this.props.motherId) }>{ this.props.motherName }</a>
					</div>: '' }
				<a className="inner" onClick= { e => this.props.onClick(e, this.props.id) }>
	                <div className="box">
	                    { this.props.img !== null?<img src={this.props.img} alt="" />:<img src="/img/default.png" height={95} alt="" /> }

	                </div>
	                <div className="box">
						<h1>{ name }</h1>
	                    <h2>{ this.props.affinity }</h2>
						<div>
							{ this.props.birthDate !== '' ?<span>
							   { this.props.birthDate }
						   </span>:''}
						   { this.props.deathDate !== '' ?<span>
							  - { this.props.deathDate }
						  </span>:''}
						</div>

	                    { this.props.city !== ''?<div>
	                        { this.props.city }
	                    </div>:<div></div>}
	                </div>
	            </a>
			</div>

        );
    }
}



// WEBPACK FOOTER //
// ./components/ProfileItemComp.tsx